import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../../../services/home.service';

import Swal from 'sweetalert2';
import { FormGroup } from '@angular/forms';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../../services/user';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs';

import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ClientsService } from '../../../../services/clients.service';
import { ClientService } from '../../../../services/clients';
import { get } from 'http';
import { ComplexService } from '../../../../services/complexrequest';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import e from 'express';

@Component({
  selector: 'app-my-complex-request',
  templateUrl: './my-complex-request.component.html',
  styleUrl: './my-complex-request.component.scss'
})
export class MyComplexRequestComponent {

  @Input() isProfile: string = "";

  allData: any[] = [];
  userimage!: string;
  userData!: users;
  username!: string;
  userPhone: string = '';
  userName: string = '';
  profile!: boolean;
  userfirstname: string = '';
  userFacebook: string = '';
  userInstgram: string = '';
  userTiktok: string = '';

  displayedColumns: string[] = [
    'complex_name',
    'complex_location',
    'request_details',
    'notes',
    'status',
    'options'
  ];

  contentReady: boolean = true;
  noData: boolean = false;
  showPopUp: boolean = false;
  showRejectPopUp: boolean = false;
  orderchange!: FormGroup;
  reason: string = "";
  orderId!: any;
  statuslist: any;
  clear: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  stockTotal!: any;
  totalItems!: any;
  searched: boolean = false;
  isAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '1')
  );
  isSubAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '6')
  );
  showoptions: boolean = false;
  searchKey: string = '';
  isAr: boolean = localStorage.getItem("language") == "ar";
  dataSource: MatTableDataSource<any>;
  isMobile: boolean = false;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private router: Router,
    private _clientsService: ClientsService,
    private _complex: ComplexService,
    private _profileService: ProfileService,
    private deviceService: DeviceDetectorService,
    private excelExportService: ExcelExportService,
    private _userService: UserService,
  ) {
    this.dataSource = new MatTableDataSource(this.allData);
  }
  ngOnInit(): void {
    this.isAdmin$.subscribe(value => console.log('isAdmin:', value));
    this.isMobile = this.deviceService.isMobileDevice();
    if (this.isMobile) {
      this.displayedColumns = [
        'complex_name',
        'request_details',
      ];
    }
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1";
        this.isSubAdmin = this.accountType == "6";
        this.getAllClients(10, 1);
        if (this.isAdmin) {
          this.displayedColumns.push('add_by');
        }
      },
      error: (error) => console.error(error),
    });
  }
     formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);
    return `${day}-${month}-${year}`;
  }
  search() {
    if (this.searchKey != null && this.searchKey != undefined && this.searchKey != "") {
      this.contentReady = true;
      this._complex.searchComplex(this.searchKey).subscribe({
        next: (data) => {
          this.allData = data['data'];
          this.dataSource = new MatTableDataSource(this.allData);
          this.contentReady = false;
          if (this.allData.length === 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        },
        error: (error) => console.error(error),
      });
    }
  }
  exportToExcel(): void {
    this.excelExportService.exportToExcel('Clients', 'AhmedElshahatClients', ['actions']);
  }
  delete(id: any) {
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._complex.delete(id).subscribe({
          next: (res) => {
            this.getAllClients(10, 1);
          },
          error: (err) => console.log(err),
        });
      }
    });
  }
  edit(itemobj: any) {
    this.router.navigate(['/createcomplex'], { queryParams: itemobj });
  }
  getAllClients(perpage: any, page: any) {
    this.contentReady = true;
    this.searched = false;
    this._complex.getAll(perpage, page).subscribe({
      next: (data) => {

        let all = data['data'];
        if(this.isAdmin)
        this.allData = all;
        else
         this.allData = all.filter((item: any) => item.status !== 1 && item.status !== 3);
        
        this.stockTotal = data['last_page'];
        this.totalItems = data['total'];
        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  onPaginateChange(event: PageEvent) {
    const newPage = event.pageIndex + 1; // MatPaginator is 0-based
    this.getAllClients(10, newPage);
  }
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  call(phone: any) {
    window.open("tel:+" + phone, '_blank');
  }
  chat(phone: any) {
    window.open("https://api.whatsapp.com/send?phone=2" + phone, '_blank');
  }
  changeComplex(id: number, status: number) {
    this._complex.updateStatus(id, status).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل حالة الطلب" : 'Client status updated',
          showConfirmButton: false,
          timer: 1500,
        });
        this.getAllClients(10, 1);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل تعديل حالة الطلب" : 'Client status not updated',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });
      }
    });
  }
}